<template>
  <span class="value-show">{{value}}</span>
</template>

<script>
export default {
  props: ['item', 'column', 'model'],
  computed: {
    value(){
      if(this.column.i18n) {
        return this.$t(`models.${this.model}.collection.${this.column.name}.${this.item[this.column.name]}`)
      } else {
        let shouldEvaluate = true;
        let _this = this;
        let splitValues = this.column.name.split('.');

        if (splitValues.length > 1) {
          let splitValue;

          splitValues.forEach((split, index) => {
            if (shouldEvaluate) {
              splitValue = eval('_this.item.' + splitValues.slice(0, (index + 1)).join('.'))

              if (!splitValue) shouldEvaluate = false;
            }
          })
        }

        if (shouldEvaluate) {
          return eval('this.item.' + this.column.name)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CollectionValueShow.vue?f869d812